export const formatDate = (isoString) => {
    if (!isoString) return "Invalid Date";
    const date = new Date(isoString);
    const options = {
        month: "short",
        day: "numeric",
        year: "numeric",
        timeZone: "America/New_York"
    };
    return date.toLocaleDateString("en-US", options);
};


export const formatTime = (isoString) => {
    if (!isoString) return "Invalid Time";
    const date = new Date(isoString);
    const options = {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
        timeZone: "America/New_York",
    };
    return date.toLocaleTimeString("en-US", options);
};


export const usDateFormatTimeUs = (dateString) => {
    const date = new Date(dateString);

    const usDateTime = date.toLocaleString("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
    });

    return usDateTime;
};

